import styled from 'styled-components';
import colors from '../ui/colors';

export const Label = styled.label`
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: #404040;
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.input`
  position: relative;
  appearance: none;
  height: 1.25em;
  width: 1.25em;
  margin: 0 0.5em 0 0;
  border: 1px solid #aaa;
  border-radius: 2px;
  background-color: #fff;
  font-size: inherit;
  cursor: pointer;
  flex-shrink: 0;

  &:checked:before {
    content: '\u2713';
    position: absolute;
    font-size: 0.85em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
    width: 100%;
    line-height: inherit;
    top: 0;
    left: 0;
    color: ${colors.BRAND_GREEN};
    box-sizing: border-box;
  }
`;

export default Checkbox



// WEBPACK FOOTER //
// ./src/modules/common/components/checkbox/CheckBox.js